export default __webpack_public_path__ + "static/media/10Symantec.3df145ff.svg";